import React, { useEffect } from "react";
import GridItem from "../../../../Components/UiComponents/GridItem/GridItem";
import { GridStack } from "gridstack";
import DMSHeader from "../../DMSHeader/DMSHeader";
import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import "../ReportEnhanced.css";

const DailyFloodReportComp = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title={t("floodreport.title")} />
      </div>
      <div className="report-table-enhanced">
        <DailyFloodReportCompTable />
      </div>
    </div>
  );
};

export default DailyFloodReportComp;
